<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="roleDetails && roleAccesses">
          <h1 class="mb-3">تنظیم دسترسی های {{ roleDetails.title }}</h1>
          <app-collapse accordion type="margin">
            <template v-for="(role, index) in roleAccesses">
              <app-collapse-item :key="index" :title="role.title">
                <div class="d-flex flex-column" style="gap: 1rem">
                  <b-form-checkbox
                    v-for="(child, index) in role.childs"
                    :key="index"
                    v-model="child.isChecked"
                    name="check-button"
                    switch
                    inline
                  >
                    {{ child.title }}
                  </b-form-checkbox>
                </div>
              </app-collapse-item>
            </template>
          </app-collapse>
          <div class="d-flex align-content-center justify-content-end">
            <b-button variant="primary" class="my-2" @click="setAccessesToRole">
              بروزرسانی
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BButton,
  BTable,
  BMedia,
  BModal,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import {
  GetAUserType,
  GetRoleAccesses,
  UpdateRoleAccesses,
} from "@/libs/Api/UserType";
import { GetAllAccessFromSystem } from "@/libs/Api/Access";
// import { GetRoleAccesses } from "@/libs/Api/RoleAccess";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import roleTranslate from "./roleTranslate.json";
export default {
  created() {
    this.accessNames = roleTranslate[0];
  },
  mounted() {
    this.getUserRole();
    this.getRoleAccesses();
    // this.getAllRoleAccesses();
    // this.getRoleAccessesById();
  },
  data() {
    return {
      isLoading: false,
      accessNames: null,
      roleDetails: null,
      roleAccesses: null,
      accessIdList: [],
    };
  },
  methods: {
    async getRoleAccesses() {
      try {
        this.isLoading = true;
        let _this = this;
        let getRoleAccesses = new GetRoleAccesses(_this);
        getRoleAccesses.setRequestParam({ UserTypeId: _this.$route.params.id });
        await getRoleAccesses.fetch((res) => {
          _this.roleAccesses = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setNewAccessListForRole() {
      this.accessIdList = [];
      this.roleAccesses.forEach((controller) => {
        controller.childs?.forEach((action) => {
          if (action.isChecked) {
            this.accessIdList.push(action.id);
          }
        });
      });
    },
    async setAccessesToRole() {
      this.setNewAccessListForRole();
      try {
        this.isLoading = true;
        let _this = this;
        let updateRoleAccesses = new UpdateRoleAccesses(_this);
        updateRoleAccesses.setRequestParamDataObj({
          accessCtrlActionIds: _this.accessIdList,
          userTypeId: _this.$route.params.id,
        });
        await updateRoleAccesses.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بروز شد!",
                icon: "EditIcon",
                variant: "success",
                text: "دسترسی های این نقش بروز شدند!",
              },
            });
            _this.newUserTypeDetails = {
              userTypeId: 0,
              name: null,
              description: null,
            };
            _this.getRoleAccesses();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بروز نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    // async sendAccessRequests() {
    //   await this.revokeAccessFromRole();
    //   await this.createAccessForRole();
    //   this.$toast({
    //     component: ToastificationContent,
    //     props: {
    //       title: "دسترسی ها با موفقیت تنظیم شد",
    //       icon: "UserCheckIcon",
    //       variant: "success",
    //     },
    //   });
    //   this.getUserRole();
    //   this.getAllRoleAccesses();
    //   this.getRoleAccessesById();
    // },
    // async revokeAccessFromRole() {
    //   try {
    //     this.isLoading = true;
    //     let _this = this;
    //     let deleteFromRole = new DeleteFromRole(_this);
    //     deleteFromRole.setRequestParam({ roleId: _this.$route.params.id });
    //     deleteFromRole.setRequestParamDataObj(this.deactiveAccessForThisRole);
    //     await deleteFromRole.fetch(
    //       function (response) {},
    //       function (error) {
    //         console.error(error);
    //       }
    //     );
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    // async createAccessForRole() {
    //   try {
    //     this.isLoading = true;
    //     let _this = this;
    //     let createForRole = new CreateForRole(_this);
    //     createForRole.setRequestParam({ roleId: _this.$route.params.id });
    //     createForRole.setRequestParamDataObj(_this.activeAccessForThisRole);
    //     await createForRole.fetch(
    //       function (response) {},
    //       function (error) {
    //         console.error(error);
    //       }
    //     );
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    isAccessChecked(access) {
      if (this.activeAccessForThisRole.includes(access)) {
        return true;
      }
      return false;
    },
    // async getRoleAccessesById() {
    //   try {
    //     this.isLoading = true;
    //     let _this = this;
    //     let getRoleAccessesBy = new GetRoleAccessesBy(_this);
    //     getRoleAccessesBy.setRequestParam({ roleId: _this.$route.params.id });
    //     await getRoleAccessesBy.fetch(
    //       function (response) {
    //         _this.activeAccessForThisRole = response.data.accesses;
    //       },
    //       function (error) {
    //         console.error(error);
    //       }
    //     );
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    handleToggleAccess(item) {
      if (this.activeAccessForThisRole.includes(item)) {
        // This section revoke accesses from a role
        this.activeAccessForThisRole = this.activeAccessForThisRole.filter(
          (access) => item != access
        );
        this.deactiveAccessForThisRole.push(item);
      } else {
        // This section add new accesses to a role
        this.deactiveAccessForThisRole = this.deactiveAccessForThisRole.filter(
          (access) => item != access
        );
        this.activeAccessForThisRole.push(item);
      }
    },
    // async getAllRoleAccesses() {
    //   try {
    //     this.isLoading = true;
    //     let _this = this;
    //     let getAllAccessFromSystem = new GetAllAccessFromSystem(_this);
    //     getAllAccessFromSystem.fetch(
    //       function (response) {
    //         _this.roleAccesses = response.data;
    //       },
    //       function (error) {
    //         console.error(error);
    //       }
    //     );
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    async getUserRole() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAUserType = new GetAUserType(_this);
        getAUserType.setRequestParamDataObj(_this.$route.params.id);
        await getAUserType.fetch(
          function (response) {
            _this.roleDetails = response;
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    AppCollapse,
    AppCollapseItem,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
